module.exports = __webpack_public_path__ + "img/phones-light@2x.675f10f3.png";